﻿class OpenYoutubeModal {
    constructor() {
        $('.open-youtube-popup').magnificPopup({
            type: 'iframe',
            closeOnContentClick: true,
            mainClass: 'mfp-img-mobile',
            image: {
                verticalFit: true
            },
            iframe: {
				markup: '<div class="mfp-iframe-scaler">' +
					'<div class="mfp-close"></div>' +
					'<iframe class="mfp-iframe" frameborder="0" allow="autoplay"></iframe>' +
					'</div>',
				patterns: {
					youtube: {
                        index: 'https://www.youtube.com/',
                        id: function (url) {
                            var m = url.match(/[\\?\\&]v=([^\\?\\&]+)/);
                            if (!m || !m[1]) return null;
                            return m[1];
                        },
						src: 'https://www.youtube-nocookie.com/embed/%id%?autoplay=1&iframe=true'
					}
				}
			}
        });
    }
}

export default OpenYoutubeModal;